<template>
    <v-dialog v-model="dialog.show" persistent max-width="460">
        <v-card tile flat>
            <v-card-title class="headline">Hiányzó esemény létrehozása</v-card-title>
            <v-card-text>
                Esemény időpontja
                <v-card tile flat class="transparent theme-border timePicker">
                    <v-container class="pa-0">
                        <v-row no-gutters>
                            <v-col cols="12" sm="5">
                                <v-btn depressed tile width="100%" class="transparent"
                                       @click="increaseMinute">
                                    <v-icon style="font-size: 28px;">mdi-chevron-up</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="2"></v-col>
                            <v-col cols="12" sm="5">
                                <v-btn depressed tile width="100%" class="transparent"
                                       @click="increaseSecond">
                                    <v-icon style="font-size: 28px;">mdi-chevron-up</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row no-gutters height="70px" align="center" justify="center">
                            <v-col cols="12" sm="5">
                                <v-card class="text-center display-1 transparent" tile flat>
                                    <span v-if="dialog.item.minute < 10">0</span>{{dialog.item.minute}}
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-card class="text-center display-1 transparent" tile flat>:</v-card>
                            </v-col>
                            <v-col cols="12" sm="5">
                                <v-card class="text-center display-1 transparent" tile flat>
                                    <span v-if="dialog.item.second < 10">0</span>{{dialog.item.second}}
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12" sm="5">
                                <v-btn depressed tile width="100%" class="transparent"
                                       @click="decreaseMinute">
                                    <v-icon style="font-size: 28px;">mdi-chevron-down</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="2"></v-col>
                            <v-col cols="12" sm="5">
                                <v-btn depressed tile width="100%" class="transparent"
                                       @click="decreaseSecond">
                                    <v-icon style="font-size: 28px;">mdi-chevron-down</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>

                <v-select v-model="dialog.item.team"
                          label="Csapat"
                          :items="teams"
                          :item-text="(team) => team.name"
                />

                <v-select v-model="dialog.item.action"
                          label="Esemény"
                          :items="actions"
                          :item-text="(action) => action.name"
                />

                <v-textarea
                    v-model="dialog.item.message"
                    name="missing-message"
                    label="Üzenet"
                ></v-textarea>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn depressed tile @click="close">Mégsem</v-btn>
                <v-btn depressed tile color="green" @click="save" :disabled="disabledSave">Mentés</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import CONSTANTS from "@/constants";
    import eventBus from '@/eventBus';
    import TimeFormatter from "@/TimeFormatter";

    import busListeners from "@/mixins/busListeners";

export default {
    mixins: [busListeners],
        name: 'MissingDialog',
        props: {
            getLabel: Function,
            getPeriod: Function,
            gamedata: Object,
            period: String
        },
        components: {
        },
        data: function () {
            return {
                dialog: {
                    show: false,
                    item: {
                        minute: 0,
                        second: 0,
                        period: '',
                        action: '',
                        team: '',
                        message: '',
                        totalTime: 0
                    }
                },
                teams: [{
                        value: 'teamA',
                        name: this.gamedata.team_a_name
                    },
                    {
                        value: 'teamB',
                        name: this.gamedata.team_b_name
                    }],
                actions: this.getActions(),
            }
        },
        created() {
            let self = this;

            this.$busOn(CONSTANTS.DMR.MISSING_MODAL, function () {
                self.dialog.show = true;
                self.dialog.item.period = self.period;
                // A hiányzó esemény dialógus a CÉL periódus bázisidejét használja,
                // nem a jelenlegi stopper pozícióját
                let targetPeriod = self.dialog.item.period || window.period;
                let periods = window.gamedata ? window.gamedata.periods : null;
                if (periods) {
                  let pItem = periods.find(p => p.value === targetPeriod);
                  self.dialog.item.totalTime = pItem ? (pItem.startat || 0) : 0;
                } else {
                  self.dialog.item.totalTime = window.stopwatch.getTrueTotalTime();
                }

                let actualTime = window.stopwatch.getTotalTime();

                self.dialog.item.minute = Math.floor(actualTime / 60);
                self.dialog.item.second = Math.floor(actualTime % 60);
            });
        },
        methods: {
            close: function () {
                this.dialog = {
                    show: false,
                    item: {
                        minute: 0,
                        second: 0,
                        period: '',
                        action: '',
                        team: '',
                        message: '',
                        totalTime: 0
                    }
                }
            },
            save: function () {
                let self = this;
                let item = self.dialog.item;
                let absoluteTime = item.minute * 60 + item.second;
                let relativeTime = absoluteTime - item.totalTime;
                let direction = null;

                if(['gol', 'gol7m', 'kapufa7m', 'vedett7m', 'rontott7m', 'dmr-timeOut'].includes(item.action)) {
                    direction = item.team === 'teamA' ? 'left' : 'right';
                }

                let newItem = {
                    UUID: window.dbmanager.generateUUID(),
                    action: item.action,
                    params: {
                        selectedAction: {
                            actionId: item.action,
                            actionName: self.getLabel(item.action),
                        },
                        otherTeamGoalKeeper: {
                            id: null
                        },
                        selectedActionType: null,
                        selectedArea: null,
                        selectedGateArea: null,
                        selectedPlayer: null,
                        selectedScapegoat: null,
                        selectedTeam: item.team === 'teamA' ? 1 : 2,
                        selectedTeamId: item.team,
                        teamScore: {
                            teamA: 0,
                            teamB: 0
                        },
                        attackDirection: direction,
                        approved: false,
                        rejectReason: null,
                        message: item.message,
                        isDraft: true,
                        gameTime: TimeFormatter.intToString(absoluteTime),
                    },
                    period: item.period,
                    isDraft: true,
                    gametime: relativeTime,
                    totalGameTime: absoluteTime,
                };

                if(item.action === 'dmr-timeOut') {
                    newItem.params.type = 'used';
                }

                window.dbmanager.write(newItem, false);

                eventBus.$emit(CONSTANTS.DMR.SEND_MISSING, newItem);

                self.close();
            },
            getMinTime() {
                return Math.floor(this.dialog.item.totalTime / 60);
            },
            getMaxTime() {
                let periodData = this.getPeriod(this.dialog.item.period);
                return this.getMinTime() + (periodData.duration / 60);
            },
            increaseMinute: function () {
                if(this.dialog.item.minute < this.getMaxTime()) {
                    this.dialog.item.minute++;

                    if(this.dialog.item.minute === this.getMaxTime()) {
                        this.dialog.item.second = 0;
                    }
                }
            },
            decreaseMinute: function () {
                if(this.dialog.item.minute > this.getMinTime()) {
                    this.dialog.item.minute--;
                }
            },
            increaseSecond: function () {
                if(this.dialog.item.minute === this.getMaxTime()) {
                    this.dialog.item.second = 0;
                } else {
                    if (this.dialog.item.second < 59) {
                        this.dialog.item.second++;
                    }
                }
            },
            decreaseSecond: function () {
                if(this.dialog.item.minute === this.getMaxTime()) {
                    this.dialog.item.second = 0;
                } else {
                    if (this.dialog.item.second > 0) {
                        this.dialog.item.second--;
                    }
                }
            },
            getActions: function () {
                let self = this;
                let rtn = [];
                let actionLabels = CONSTANTS.DMR.ACTION_LABELS;

                Object.keys(actionLabels).forEach(function(key) {
                    if(!['keklap', 'piroslap', 'sargalap', '2perc', '4perc', 'timeOut'].includes(key)) {
                        rtn.push({
                            value: key,
                            name: self.getLabel(key)
                        });
                    }
                });

                return rtn;
            }
        },
        computed: {
            disabledSave: function () {
                let item = this.dialog.item;

                return !item.action || !item.team || !item.message;
            }
        }
    }
</script>

<style scoped>
    .timePicker {
        width: 200px;
    }
</style>
